import { useQuery } from '@tanstack/react-query';
import { ApiModel, BulkUploadDraftSellerModel, BulkUploadDraftSellerModelConverter } from '@steelbuy/ts-shared';
import axios from '../../axios';
import { DRAFT_BULK_UPLOAD_KEY } from '../../mutations/bulk-upload/createBulkUpload';

const modelConverter = new BulkUploadDraftSellerModelConverter();

const getDraftBulkUpload = async (bulkId: string) => {
    const { data } = await axios.get<BulkUploadDraftSellerModel>(`/api/universal/bulk-listing-drafts/${bulkId}`);
    const convertedData = modelConverter.toViewModel(data as unknown as ApiModel<BulkUploadDraftSellerModel>);
    return convertedData;
};

export const useDraftBulkUpload = (bulkId: BulkUploadDraftSellerModel['bulkId']) =>
    useQuery({
        queryKey: [DRAFT_BULK_UPLOAD_KEY, bulkId],
        queryFn: () => getDraftBulkUpload(bulkId),
        enabled: !!bulkId,
        staleTime: Infinity,
        cacheTime: Infinity,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
    });
